// src/components/AdminAnnouncements/AdminAnnouncementsView.js
import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { localDate } from "../Utils/DateHelpers";

  const addLinksToMessage = (message) => {
    if(typeof message !== "string")
      return message;
    return message.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\{([^|]*?)\}/g, "<a href='$1' style='color: maroon' target='_blank'>$1</a>").replace(/{(.*?)\|(.*?)}/g, "<a href='$2' style='color: maroon' target='_blank'>$1</a>");
  };

const AdminAnnouncementsView = ({ open, onClose, announcementData }) => {
  if (!announcementData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false}>
      <DialogTitle className="mx-auto text-2xl font-bold font-brand-primary">
        VIEW ANNOUNCEMENT
      </DialogTitle>
      <DialogContent className="flex flex-col gap-4 mb-4 mx-4">
        {/* Subject */}
        <div className="flex flex-col">
          <label className="text-lg font-brand-primary mb-1">Subject</label>
          <p className="text-xl font-semibold">
            {announcementData.announcement}
          </p>
        </div>

        {/* Sender Details */}
        {announcementData.adminName ? (
          <div className="flex flex-col">
            <label className="text-lg font-brand-primary mb-1">From: </label>
            <p className="text-base">{announcementData.adminName}</p>
          </div>
        ) : (
          <>
            {announcementData.companyName && (
              <div className="flex flex-col">
                <label className="text-lg font-brand-primary mb-1">
                  Company
                </label>
                <p className="text-base">{announcementData.companyName}</p>
              </div>
            )}
            {announcementData.contactName && (
              <div className="flex flex-col">
                <label className="text-lg font-brand-primary mb-1">From</label>
                <p className="text-base">{announcementData.contactName}</p>
              </div>
            )}
          </>
        )}

        {/* Description */}
        <div className="flex flex-col">
          <label className="text-lg font-brand-primary mb-1">Description</label>
          <p className="text-base" dangerouslySetInnerHTML={{ __html: addLinksToMessage(announcementData.description) }}></p>
        </div>

        {/* Dates */}
        <div className="flex justify-between">
          <div className="flex flex-col">
            <label className="text-lg font-brand-primary mb-1">
              Start Date
            </label>
            <p className="text-base">
              {announcementData.startDate
                ? localDate(announcementData.startDate).toLocaleDateString()
                : "N/A"}
            </p>
          </div>
          <div className="flex flex-col">
            <label className="text-lg font-brand-primary mb-1">
              Expire Date
            </label>
            <p className="text-base">
              {announcementData.expireDate
                ? localDate(announcementData.expireDate).toLocaleDateString()
                : "N/A"}
            </p>
          </div>
        </div>
      </DialogContent>
      <DialogActions className="px-8 pb-4">
        <Button
          variant="contained"
          className="primary-button bg-brand-primary mb-2 h-11 pt-2 px-6"
          onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AdminAnnouncementsView.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  announcementData: PropTypes.shape({
    announcement: PropTypes.string,
    description: PropTypes.string,
    startDate: PropTypes.string,
    expireDate: PropTypes.string,
    companyName: PropTypes.string,
    contactName: PropTypes.string,
    adminName: PropTypes.string,
  }).isRequired,
};

export default AdminAnnouncementsView;
